'use client';

import { defineMessages } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { BypassBlock } from '@packages/shared/src/ui/BypassBlock/BypassBlock';
import { Link } from '@packages/modules/src/Link/Link';

import { bypassBlockMessages } from '../messages';
import type { AppBannerVariant } from './types';
import { useAppBanner } from './useAppBanner';

const messages = defineMessages({
  title: {
    id: 'compactAppBanner.title',
    defaultMessage: 'Einfacher + schneller shoppen',
  },
  action: { id: 'compactAppBanner.action', defaultMessage: 'Zur App' },
  close: { id: 'appBanner.close', defaultMessage: 'Schließen' },
});

type CompactAppBannerProps = {
  variant?: AppBannerVariant;
};

export const CompactAppBanner = ({ variant }: CompactAppBannerProps) => {
  const { isVisible, appUrl, formatMessage, handleClick, handleClose } = useAppBanner({ variant });

  if (!isVisible) {
    return null;
  }

  return (
    <div className="bg-color-grey-light relative p-1" data-testid="app-banner-compact">
      <BypassBlock
        skipScrollIntoView
        buttonText={formatMessage(bypassBlockMessages.bypassAppBanner)}
      >
        <div className="flex justify-between">
          <div className="flex items-center">
            <Button
              variant="icon-flat"
              className="h-4"
              onClick={handleClose}
              aria-label={formatMessage(messages.close)}
            >
              <div className="icon-emp-cancel" />
            </Button>
            <div className="bg-color-background-base mr-1 flex rounded-[0.5rem]">
              <div className="icon-emp-app-icon h-4 w-4" />
            </div>
            <div className="flex items-center">
              <p className="text-size-body-xs">{formatMessage(messages.title)}</p>
            </div>
          </div>
          <Link href={appUrl} onClick={handleClick} className="flex items-center no-underline">
            <Button variant="floating-action-text" className="text-size-body-xs shadow-none">
              {formatMessage(messages.action)}
            </Button>
          </Link>
        </div>
      </BypassBlock>
    </div>
  );
};
